import { js, css } from 'libs/js-beautify'

export const jsBeautify = (value, options = {}) => js(value, options)
export const cssBeautify = (value, options = {}) => css(value, options)
